/* globals hbspt */
import Combobox from '@components/combobox';

const API_URL = '/wp-json/packback/v1/institutions';
const MIN_QUERY_LEN = 2;
const DEBOUNCE_MS = 300;

async function fetchInstitutions(query) {
  const res = await fetch(API_URL, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      criteria: query
    })
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  return res.json();
}

function uniqueNames(json) {
  if (!json || !Array.isArray(json.campuses)) {
    return [];
  }

  const seen = new Set();
  const names = [];

  json.campuses.forEach((item) => {
    if (!item || !item.name) {
      return;
    }

    const name = String(item.name).trim();

    if (!name || seen.has(name)) {
      return;
    }

    seen.add(name);
    names.push(name);
  });

  return names;
}

function ensureMessageElement(formEl, companyEl) {
  if (!formEl || !companyEl) {
    return null;
  }

  let el = formEl.querySelector('.js-inst-status');

  if (!el) {
    el = document.createElement('p');
    el.className = 'js-inst-status';
    companyEl.insertAdjacentElement('afterend', el);
  }

  return window.jQuery ? window.jQuery(el) : null;
}

/**
 * type: 'error' or 'status'
 *
 * - error  -> .js-inst-status.hs-error-msg        (NO -absolute)
 * - status -> .js-inst-status.hs-status-msg.-absolute
 */
function setMessage($msg, type, text) {
  if (!$msg || !$msg[0]) {
    return;
  }

  const el = $msg[0];
  const content = text || '';

  // Reset classes to the base
  el.className = 'js-inst-status';
  el.textContent = content;

  if (!content) {
    return;
  }

  if (type === 'error') {
    el.classList.add('hs-error-msg');
  } else {
    el.classList.add('hs-status-msg');
    el.classList.add('-absolute');
  }
}

export default () => {
  hbspt.forms.create({
    region: 'na1',
    portalId: '19914184',
    formId: $('#hubspot-form').data('form'),
    target: '#hubspot-form',
    async onFormReady($form) {
      const companyEl = $form.find('input[name="company"]')[0];

      if (!companyEl) {
        return;
      }

      const $msg = ensureMessageElement($form[0], companyEl);

      // Style hook for the shared combobox component
      if (companyEl.parentNode) {
        companyEl.parentNode.classList.add('pb-combobox');
      }

      const combobox = new Combobox({
        input: companyEl,
        listbox: null,
        minQueryLen: MIN_QUERY_LEN,
        debounceMs: DEBOUNCE_MS,
        ariaLabel: 'Institution suggestions',
        onInput: () => {
          setMessage($msg, 'status', '');
          setMessage($msg, 'error', '');
        },
        onSelect: () => {
          setMessage($msg, 'status', '');
          setMessage($msg, 'error', '');
        },
        onBlurInvalid: () => {
          setMessage($msg, 'error', 'Please select your institution from the list.');
        },
        onError: () => {
          setMessage($msg, 'status', '');
          setMessage($msg, 'error', 'Unable to load institutions right now.');
        },
        getItems: async (query) => {
          setMessage($msg, 'error', '');
          setMessage($msg, 'status', 'Loading institutions…');

          const json = await fetchInstitutions(query);
          const names = Combobox.rankMatches(uniqueNames(json), query);

          if (!names.length) {
            setMessage($msg, 'status', '');
            setMessage($msg, 'error', 'No institutions found. Please search again.');
            return [];
          }

          setMessage($msg, 'status', '');
          return names;
        }
      });

      // If HubSpot prefills this field, treat it as already selected unless the user edits it.
      const initialValue = String(companyEl.value || '').trim();
      if (initialValue) {
        combobox.setSelectedValue(initialValue);
      }

      $form.on('submit', (event) => {
        const value = String(companyEl.value || '').trim();

        if (!value || !combobox.isSelected()) {
          setMessage($msg, 'error', 'Please select your institution from the list.');
          event.preventDefault();
          return false;
        }

        setMessage($msg, 'status', '');
        setMessage($msg, 'error', '');
        return true;
      });
    }
  });
};
